import { useCallback, useMemo } from 'react'
import { useFieldArray } from 'react-hook-form'
import { v4 as uuidV4 } from 'uuid'
import {
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { ruleActionsForUnpaid } from 'subapps/settings/components/drawers/RuleCreateEdit/data'

import Action from 'subapps/settings/components/Action'

const ACTIONS = ['assignee_id', 'assignee_group_id', 'snooze_until', 'status']

const prepareAutomaticActionsParameters = fields => {
  const pickedFieldTypes = fields.map(f => f.type)
  const parameters = [
    ...ruleActionsForUnpaid.parameters.filter(p => ACTIONS.includes(p.value)),
    { name: 'Remove tag', value: 'label_remove', parameterType: 'id' },
    { name: 'Remove all tags', value: 'label_remove_all' },
  ].map(p => ({
    name: p.name,
    value: p.value,
    disabled: pickedFieldTypes.includes(p.value),
  }))

  return parameters
}

const CannedReplyAutomaticActions = ({ control, trigger, setValue }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'automatic_actions',
  })
  const filteredFields = fields.filter(f => f.type !== 'labels_by_id')

  const onAdd = useCallback(
    () => {
      const newEntity = {
        operator: null,
        param: null,
        value: '',
        key: uuidV4(),
      }
      append(newEntity)
    },
    [append]
  )

  const onRemove = useCallback(
    (action, index) => {
      remove(index)
    },
    [remove]
  )

  const onChange = useCallback(
    (newEntity, index) => {
      setValue(`automatic_actions.${index}`, newEntity, {
        shouldDirty: true,
        shouldValidate: true,
      })
      trigger(`automatic_actions.${index}`)
    },
    [setValue, trigger]
  )

  const automaticActionsVariables = useMemo(
    () => {
      const parameters = prepareAutomaticActionsParameters(fields)
      const values = {
        ...ruleActionsForUnpaid.values,
        label_remove: {
          dataType: 'TAGS',
          paramType: 'id',
        },
        label_remove_all: {
          dataType: 'NONE',
        },
      }

      return {
        parameters,
        values,
      }
    },
    [fields]
  )

  return (
    <div>
      <div>
        {fields.map((item, index) => {
          const { id, key } = item

          if (item.type === 'labels_by_id') {
            return null
          }

          return (
            <Action
              control={control}
              name={`automatic_actions.${index}`}
              key={`automatic-action-${id}-${key}`}
              variables={automaticActionsVariables}
              index={index}
              onRemoveAction={onRemove}
              onActionChange={onChange}
              onInput={onChange}
              totalActions={filteredFields.length + 1}
            />
          )
        })}
      </div>

      <div className="grui mt-5">
        <button
          type="button"
          css={[
            button.styles.link,
            text.styles.textXs,
            text.styles.textPrimary,
          ]}
          onClick={onAdd}
        >
          + Add action
        </button>
      </div>
    </div>
  )
}

export default CannedReplyAutomaticActions
